import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import ClientCarNew from 'components/modals/ClientCarNew';

class AddYourCar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showNew: false,
    };
  }

  showNew = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ showNew: true });
  };

  closeNew = () => {
    this.setState({ showNew: false });
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { showNew } = this.state;

    return (
      <Col xs={12} md={6} lg={3} className="m-t-20 grid-item">
        <div className="widget-11 card no-margin b-grey b-a">
          <div className="card-header p-t-20 p-l-15">
            <div className="card-title">
              <i className="fal fa-car" /> {messages.add_my_vehicle}
            </div>
          </div>
          <div className="card-content bg-master-lighter p-t-35 p-b-35 text-center">
            <a href="#new" onClick={this.showNew}>
              <i className="fad fa-plus-circle fa-4x" />
            </a>
          </div>
          <div className="card-footer clearfix">
            <ul className="reactions">
              <li>
                <a href="#new" onClick={this.showNew}>
                  {messages.add} <i class="fad fa-arrow-circle-right" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <ClientCarNew show={showNew} close={this.closeNew} />
      </Col>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.carNew,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(AddYourCar)));
